export default {
    name: 'Cell',
    props: {
        layoutConfig: {
            type: Object,
            required: true
        }
    },
    computed: {
        cellArea() {
            const positionInfo = this.layoutConfig.PositionInfo;
            if (!positionInfo) {
                return '';
            }
            return `${positionInfo.Row} / ${
                positionInfo.Column
            } / ${positionInfo.Row +
                positionInfo.Rows} / ${positionInfo.Column +
                positionInfo.Columns}`;
        }
    },
    render(h) {
        return (
            <div
                class="cell-layout"
                style={{
                    gridArea: this.cellArea
                }}
            >
                {this.$slots.default}
            </div>
        );
    }
};
